// ========================================
// 定数定義
// ========================================
const BREAKPOINTS = {
	SP: 559,
	TABLET: 959
};

const SCROLL_SPEED = 2000;
const SCROLL_EASING = 'easeInOutQuad';

// ========================================
// ユーティリティ
// ========================================

function getSystemInfo() {
	const ua = navigator.userAgent.toLowerCase();
	let browserClass = '';
	let osClass = '';

	if (ua.indexOf('edge') !== -1 || ua.indexOf('edg') !== -1) {
		browserClass = 'browser-edge';
	} else if (ua.indexOf('opera') !== -1 || ua.indexOf('opr') !== -1) {
		browserClass = 'browser-opera';
	} else if (ua.indexOf('chrome') !== -1) {
		browserClass = 'browser-chrome';
	} else if (ua.indexOf('safari') !== -1) {
		browserClass = 'browser-safari';
	} else if (ua.indexOf('firefox') !== -1) {
		browserClass = 'browser-firefox';
	} else if (ua.indexOf('msie') !== -1 || ua.indexOf('trident') !== -1) {
		browserClass = 'browser-ie';
	}

	if (ua.indexOf('windows') !== -1) {
		osClass = 'os-windows';
	} else if (ua.indexOf('mac os x') !== -1) {
		osClass = 'os-mac';
	} else if (ua.indexOf('iphone') !== -1 || ua.indexOf('ipad') !== -1 || ua.indexOf('ipod') !== -1) {
		osClass = 'os-ios';
	} else if (ua.indexOf('android') !== -1) {
		osClass = 'os-android';
	} else if (ua.indexOf('linux') !== -1) {
		osClass = 'os-linux';
	}

	return { browser: browserClass, os: osClass };
}

function deviceSizeFunc(callback) {
	const w = $(window).width();
	if (w <= BREAKPOINTS.SP) {
		if (typeof callback.sp === 'function') callback.sp();
	} else if (w <= BREAKPOINTS.TABLET) {
		if (typeof callback.tablet === 'function') callback.tablet();
	} else {
		if (typeof callback.pc === 'function') callback.pc();
	}
	if (w > BREAKPOINTS.SP) {
		if (typeof callback.overSp === 'function') callback.overSp();
	}
}

// スマートフォン表示の処理
function handleSmartphoneView() {
	/*$(".tel-number").each(function(){
		if(!$(this).parent(".tel-wrap").length){
			const no = $(this).data("tel").replace(/-/g,"");
			$(this).wrap('<a href="tel:' + no + '" class="tel-wrap"></a>');
		}
	});*/
}

// スマートフォンより大きい画面の処理
function handleOverSmartphoneView() {
	$(".tel-wrap .tel-number").each(function() {
		$(this).unwrap();
	});
}

// ========================================
// 初期化関数（init*）
// ========================================

// メニュー機能の初期化（open時はbodyをfixedでスクロール禁止）
function initMenu() {
	function closeMenuIfNeeded() {
		const $body = $("body");
		if (!$body.hasClass("menu-open")) return;
		const scrollY = parseInt($body.css("top") || "0", 10) * -1;
		$body.removeClass("menu-open").css("top", "");
		window.scrollTo(0, scrollY);
	}

	$("#menu-btn").on("click", function() {
		const $body = $("body");
		if ($body.hasClass("menu-open")) {
			const scrollY = parseInt($body.css("top") || "0", 10) * -1;
			$body.removeClass("menu-open").css("top", "");
			window.scrollTo(0, scrollY);
		} else {
			const scrollY = window.scrollY;
			$body.addClass("menu-open").css("top", -scrollY + "px");
		}
	});
	$(".gnavi-list a").on("click", function(e) {
		const href = $(this).attr("href") || "";
		const hash = href.indexOf("#") >= 0 ? "#" + href.split("#")[1] : "";
		const isAnchorTarget = 1;//hash === "#top-access" || hash === "#top-gallery";
		const $target = isAnchorTarget ? $(hash) : $();

		if (isAnchorTarget && $target.length) {
			e.preventDefault();
			closeMenuIfNeeded();
			const headerHeight = $('header').outerHeight();
			const adjustHeight = headerHeight;
			$("html, body").animate(
				{ scrollTop: $target.offset().top - adjustHeight },
				SCROLL_SPEED,
				SCROLL_EASING
			);
			return;
		}

		closeMenuIfNeeded();
	});
}

// キービジュアルスライダー（Swiper）
function initKeySlider() {
	const $keyBg = $('.key-bg.swiper');
	if (!$keyBg.length) return;
	if (typeof Swiper === 'undefined') return;

	new Swiper('.key-bg', {
		loop: true,
		autoplay: {
			delay: 4000,
			disableOnInteraction: false
		},
		effect: 'fade',
		speed: 2000,
		allowTouchMove: false
	});
}

// 画像スライダー（.slider.swiper：CONCEPT インテリア等）
// クラスでエフェクト切替：.slider-fade → fade / なし → 横スライド
// 併用可：.slider-auto → autoplay
function initImageSlider() {
	if (typeof Swiper === 'undefined' || !$('.slider.swiper').length) return;
	$('.slider.swiper').each(function() {
		const $el = $(this);
		const $paginationEl = $el.find('.swiper-pagination');
		const $nextEl = $el.find('.swiper-button-next');
		const $prevEl = $el.find('.swiper-button-prev');
		const hasAutoClass = $el.hasClass('slider-auto');
		const isFade = $el.hasClass('slider-fade');

		const swiperConfig = {
			loop: false,
			speed: 1600,
			keyboard: {
				enabled: true,
				onlyInViewport: true
			},
			observer: true,
			observeParents: true
		};

		if (isFade) {
			swiperConfig.effect = 'fade';
			swiperConfig.fadeEffect = {
				crossFade: true
			};
			swiperConfig.spaceBetween = 0;
		} else {
			swiperConfig.spaceBetween = 100;
		}

		// paginationが存在する場合のみ設定
		if ($paginationEl.length) {
			swiperConfig.pagination = {
				el: $paginationEl[0],
				clickable: true
			};
		}

		// navigationボタンが存在する場合のみ設定
		if ($nextEl.length || $prevEl.length) {
			swiperConfig.navigation = {};
			if ($nextEl.length) swiperConfig.navigation.nextEl = $nextEl[0];
			if ($prevEl.length) swiperConfig.navigation.prevEl = $prevEl[0];
		}

		if (hasAutoClass) {
			swiperConfig.autoplay = {
				delay: 5000,
				disableOnInteraction: false
			};
		}

		new Swiper(this, swiperConfig);
	});
}



// スクロールフェードイン（Intersection Observer）
function initScrollFadeIn() {
	const $fadeInEls = $('.js-scroll-fadein');
	if (!$fadeInEls.length) return;
	const observer = new IntersectionObserver(function(entries) {
		$(entries).each(function(index, entry) {
			if (entry.isIntersecting) $(entry.target).addClass('is-visible');
		});
	}, { root: null, rootMargin: '0px 0px -20% 0px', threshold: 0 });
	$fadeInEls.each(function() { observer.observe(this); });
}

// ヘッダーのスクロール時クラス付与
function initHeaderScroll() {
	const $header = $('header');
	if (!$header.length) return;

	let isScrolled = false;
	
	function updateHeaderClass() {
		const scrollTop = $(window).scrollTop();
		if (scrollTop >= 200 && !isScrolled) {
			$header.addClass('is-scrolled');
			isScrolled = true;
		} else if (scrollTop < 200 && isScrolled) {
			$header.removeClass('is-scrolled');
			isScrolled = false;
		}
	}

	$(window).on('scroll', updateHeaderClass);
	// 初期表示時にも状態を反映
	updateHeaderClass();
}

// ニュース一覧：Load More（index_2.html, index_3.html... を順に読み込み）
/*function initNewsLoadMore() {
	if (!$('#news.bn-index').length) return;
	const $btnLoad = $('.btn-load');
	const $newsList = $('#news-list .news-list');
	if (!$btnLoad.length || !$newsList.length) return;

	let nextPageNumber = 2;
	const staggerDelay = 80;

	function fadeInItems($items) {
		$items.each(function(i) {
			const $el = $(this);
			setTimeout(function() { $el.addClass('is-visible'); }, i * staggerDelay);
		});
	}

	function getNextPageUrl() {
		return 'index_' + nextPageNumber + '.html';
	}

	$btnLoad.on('click', function() {
		const url = getNextPageUrl();
		const urlOneAhead = 'index_' + (nextPageNumber + 1) + '.html';
		const $btn = $(this);
		$btn.addClass('is-loading').prop('disabled', true);
		let oneAheadIs404 = false;
		let mainCompleted = false;

		function maybeHideButton() {
			if (oneAheadIs404 && mainCompleted) $btn.hide();
		}

		$.get(urlOneAhead).fail(function(xhr) {
			if (xhr.status === 404) {
				oneAheadIs404 = true;
				maybeHideButton();
			}
		});

		$.get(url).done(function(html) {
			const $loaded = $(html);
			const $items = $loaded.find('#news-list .news-list').children();
			if (!$items.length) {
				$btn.hide();
			} else {
				$items.addClass('news-item-load');
				$newsList.append($items);
				fadeInItems($items);
				nextPageNumber++;
			}
			mainCompleted = true;
			maybeHideButton();
			$btn.removeClass('is-loading').prop('disabled', false);
		}).fail(function(xhr) {
			$btn.removeClass('is-loading').prop('disabled', false);
			if (xhr.status === 404) $btn.hide();
		});
	});
}*/

// ========================================
// スクロール・ハッシュ
// ========================================

// ハッシュがあればその位置へスクロール
function scrollToHash() {
	if (!location.hash) return;
	const target = $(location.hash);
	if (!target.length) return;
	const headerHeight = $('header').outerHeight();
	let adjustHeight = headerHeight;
	window.scrollTo(0, target.offset().top - adjustHeight);
}

var SEARCH_CAL_WAIT_TIMEOUT = 8000;
// #searchCal の読み込み完了を待ってから scrollToHash を実行
function runScrollToHashWhenReady() {
	if (!location.hash) return;
	function doScroll() {
		requestAnimationFrame(function() {
			requestAnimationFrame(scrollToHash);
		});
	}
	const searchCal = document.getElementById('searchCal');
	if (!searchCal || searchCal.children.length > 0) {
		doScroll();
		return;
	}
	const timeout = setTimeout(doScroll, SEARCH_CAL_WAIT_TIMEOUT);
	const observer = new MutationObserver(function() {
		if (searchCal.children.length > 0) {
			observer.disconnect();
			clearTimeout(timeout);
			doScroll();
		}
	});
	observer.observe(searchCal, { childList: true, subtree: true });
}

// ========================================
// イベント登録・エントリポイント
// ========================================

// 画面サイズごとの処理
$(window).on('load resize', function() {
	deviceSizeFunc({
		sp: handleSmartphoneView,
		tablet: function() {},
		pc: function() {},
		overSp: handleOverSmartphoneView
	});
});

// アンカーリンクのスムーズスクロール
$('a[href^="#"]').on('click', function() {
	const href = $(this).attr('href');
	const isGnaviSpecialAnchor = 1;//$(this).closest('.gnavi-list').length && (href === '#top-access' || href === '#top-gallery');
	if (isGnaviSpecialAnchor) return; 
	const target = $(href == '#' || href == '' ? 'html' : href);
	const headerHeight = $('header').outerHeight();
	let adjustHeight = headerHeight;
	if (!target.hasClass('is-visible')) {
		adjustHeight += 40;
	}
	window.scrollTo(0, target.offset().top - adjustHeight);
	return false;
});

// ページ読み込み完了時：ハッシュスクロール・ローダー・キービジュアル
$(window).on('load', function() {
	runScrollToHashWhenReady();

	const $loader = $('#loader');
	const $loaderLogo1 = $loader.find('.loader-logo1');
	const $loaderLogo2 = $loader.find('.loader-logo2');
	if (!$loader.length || !$loaderLogo1.length || !$loaderLogo2.length) {
		initKeySlider();
		return;
	}
	$loaderLogo1
		.css('opacity', 0)
		.delay(100)
		.animate({opacity:1},1000,"easeInOutQuad");
		
	$loaderLogo2
		.css('opacity', 0)
		.delay(900)
		.animate({opacity:1},1000,"easeInOutQuad",function(){
			$(".loader-logo1, .loader-logo2")
				.delay(1500)
				.animate({opacity:0},500,"easeInOutQuad");
			
			$loader
				.delay(1550)
				.animate({opacity:0},1500,"easeInOutQuad",function() {
					initKeySlider();
					$loader.animate({ opacity: 0 }, 600, function() {
						$loader.remove();
					});
				});
		});

	

});

// DOM ready：共通初期化
$(document).ready(function() {
	const systemInfo = getSystemInfo();
	if (systemInfo.browser) $('body').addClass(systemInfo.browser);
	if (systemInfo.os) $('body').addClass(systemInfo.os);

	initMenu();
	initImageSlider();
	initScrollFadeIn();
	//initNewsLoadMore();
	initHeaderScroll();

});
